import React, {useMemo} from 'react';
import {
  Link as LinkReactRouterDOM,
  LinkProps as LinkPropsReactRouterDOM,
} from 'react-router-dom';
import getUrlWithBrandId from '@/utils/getUrlWithBrandId';
import useBrandId from '@/hooks/use-brand-id';

export type LinkProps = {
  testID?: string;
  keepBrandIdIfPresent?: boolean;
} & LinkPropsReactRouterDOM;

// forwardRef so MUI slot props (`<Button component={Link}>`) can attach their
// ref instead of warning that a function component cannot be given one.
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function Link(props, ref) {
    const {testID = 'link', to, keepBrandIdIfPresent = true, ...rest} = props;
    const brandId = useBrandId();

    const finalizeTo = useMemo(() => {
      return to && keepBrandIdIfPresent ? getUrlWithBrandId(String(to)) : to;
    }, [to, keepBrandIdIfPresent, brandId]);

    // data-testid before the spread so a caller-supplied one wins over the
    // default — MUI's `component={Link}` forwards its own down to us.
    return (
      <LinkReactRouterDOM
        data-testid={testID}
        {...rest}
        ref={ref}
        to={finalizeTo}
      />
    );
  }
);

export default Link;
